import styled from "styled-components"
import * as variables from "../../../css/variables"

export default styled.div`
   .root {
      width: 100%;
      overflow: hidden;
      margin: 20px 0 20px;
      padding: 10px 20px 20px;
      object-fit: contain;
      border-radius: 16px;
      border: solid 2px #e2e2e2;
      background-color: #ffffff;
      .title {
         width: 100%;
         height: 20%;
         margin: 0 0 20px;
         background-color: white;
         text-align: center;
         padding: 10px 100px 10px 100px;
         object-fit: contain;
         border-radius: 8px;
         border: solid 1px ${variables.$denim_blue};
         span {
            @media (max-width: 990px) {
               font-size: 16px;
            }
            @media (max-width: 590px) {
               font-size: 14px;
            }
            color: ${variables.$denim_blue};
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
         }
      }
      .body {
         @media (max-width: 990px) {
            flex-direction: column;
            width: 100%;
            align-content: space-between;
            height: auto;
         }
         height: 600px;
         display: flex;
         flex-direction: row;
         justify-content: space-between;

         .right {
            @media (max-width: 990px) {
               width: 100%;
               font-size: 14px;
               margin-bottom: 20px;
            }
            @media (max-width: 590px) {
               font-size: 12px;
            }
            width: 32%;
            height: inherit;

            .items {
               @media (min-width: 990px) {
                  min-height: 100% !important;
                  overflow-y: scroll;
               }
               transition: max-height ease 0.7s;
               -moz-transition: max-height 0.7s; /* Firefox 4 */
               -webkit-transition: max-height 0.7s; /* Safari and Chrome */
               -o-transition: max-height 0.7s;
               display: flex;
               flex-direction: column;
               height: fit-content;
               overflow: hidden;
               text-align: center;
               border-radius: 8px;
               background-color: #f5f6fa;

               .item {
                  margin: 10px 0px 20px 0px;
                  max-height: fit-content;
                  display: flex;
                  flex-direction: row;
                  text-align: center;
                  justify-content: space-around;

                  .item-right {
                  }
                  .item-center {
                     font-weight: bolder;
                  }
                  .item-left {
                     color: ${variables.$warm_grey};
                  }
               }
            }

            .show-more {
               @media (max-width: 990px) {
                  display: block;
               }
               text-align: center;
               display: none;
               position: relative;
               background-image: linear-gradient(
                  to bottom,
                  rgba(194, 194, 194, 0),
                  #a2a2a2
               );
               border-bottom-right-radius: 8px;
               border-bottom-left-radius: 8px;
            }
         }
         .center {
            @media (max-width: 990px) {
               width: 100%;
               font-size: 14px;
               margin-bottom: 20px;
            }
            @media (max-width: 590px) {
               font-size: 12px;
            }
            width: 32%;
            height: inherit;

            .items {
               @media (min-width: 990px) {
                  min-height: 100% !important;
                  overflow-y: scroll;
               }
               transition: max-height ease 0.7s;
               -moz-transition: max-height 0.7s; /* Firefox 4 */
               -webkit-transition: max-height 0.7s; /* Safari and Chrome */
               -o-transition: max-height 0.7s;
               display: flex;
               flex-direction: column;
               height: fit-content;
               overflow: hidden;
               text-align: center;
               border-radius: 8px;
               background-color: #f5f6fa;

               .item {
                  margin: 10px 0px 20px 0px;
                  max-height: fit-content;
                  display: flex;
                  flex-direction: row;
                  text-align: center;
                  justify-content: space-around;

                  .item-right {
                  }
                  .item-center {
                     font-weight: bolder;
                  }
                  .item-left {
                     color: ${variables.$warm_grey};
                  }
               }
            }

            .show-more {
               @media (max-width: 990px) {
                  display: block;
               }
               text-align: center;
               display: none;
               border-bottom-right-radius: 8px;
               border-bottom-left-radius: 8px;
               position: relative;
               background-image: linear-gradient(
                  to bottom,
                  rgba(194, 194, 194, 0),
                  #a2a2a2
               );
            }
         }
         .left {
            @media (max-width: 990px) {
               width: 100%;
               font-size: 14px;
               margin-bottom: 20px;
            }
            @media (max-width: 590px) {
               font-size: 12px;
            }
            width: 32%;
            height: inherit;

            .items {
               @media (min-width: 990px) {
                  min-height: 100% !important;
                  overflow-y: scroll;
               }
               transition: max-height ease 0.7s;
               -moz-transition: max-height 0.7s; /* Firefox 4 */
               -webkit-transition: max-height 0.7s; /* Safari and Chrome */
               -o-transition: max-height 0.7s;
               display: flex;
               flex-direction: column;
               height: fit-content;
               overflow: hidden;
               text-align: center;
               border-radius: 8px;
               background-color: #f5f6fa;

               .item {
                  margin: 10px 0px 20px 0px;
                  max-height: fit-content;
                  display: flex;
                  flex-direction: row;
                  text-align: center;
                  justify-content: space-around;

                  .item-right {
                  }
                  .item-center {
                     font-weight: bolder;
                  }
                  .item-left {
                     color: ${variables.$warm_grey};
                  }
               }
            }

            .show-more {
               @media (max-width: 990px) {
                  display: block;
               }
               text-align: center;
               display: none;
               border-bottom-right-radius: 8px;
               border-bottom-left-radius: 8px;
               position: relative;
               background-image: linear-gradient(
                  to bottom,
                  rgba(194, 194, 194, 0),
                  #a2a2a2
               );
            }
         }
      }
   }
`
